export function getPermissions() {
  try {
    return JSON.parse(localStorage.getItem("permissions") || "[]");
  } catch (e) {
    return [];
  }
}

export function hasPermission(permission) {
  return getPermissions().includes(permission);
}

export function hasAnyPermission(permissions) {
  const userPerms = getPermissions();
  return permissions.some((p) => userPerms.includes(p));
}
